module.exports = __webpack_public_path__ + "media/images/workplace/login-bg@2x-ec9da64da4730e5fd605672ef40a4c41.png";